import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { QueryParams } from "../models/Po";
import { getCurrentDateOffset } from "../utils/utils";
import cloneDeep from "lodash/cloneDeep";

const oneMonthAgo = getCurrentDateOffset(-1, 0); // 現在日付から1ヶ月前
const oneYearLater = getCurrentDateOffset(0, 1); // 現在日付から1年後
const oneWeekAgo = getCurrentDateOffset(0, 0, -7); // 現在日付から1週間前

interface QueryParamsState {
  value: QueryParams;
  selectedPlantCode: string;
  selectedProcCode: string;
  machCode: string[];
  status: string;
  arrivalDateFrom: string;
  arrivalDateTo: string;
  shipDateFrom: string;
  shipDateTo: string;
}

const initialState: QueryParamsState = {
  value: {} as QueryParams,
  selectedPlantCode: "",
  selectedProcCode: "",
  machCode: [],
  status: "0,1,2,3",
  // Oracle DBのテーブルの一つの受注データには着日と出日があり、
  // これに対して範囲することでデータの取得速度を改善している
  arrivalDateFrom: oneWeekAgo, // 初期値を設定
  arrivalDateTo: oneYearLater, // 初期値を設定
  shipDateFrom: oneWeekAgo, // 初期値を設定
  shipDateTo: oneYearLater, // 初期値を設定
};

export const queryParamsSlice = createSlice({
  name: "queryParams",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<QueryParams>) => {
      state.value = cloneDeep(action.payload);
    },
    setSelectedPlantCode: (state, action: PayloadAction<string>) => {
      state.selectedPlantCode = cloneDeep(action.payload);
    },
    setSelectedProcCode: (state, action: PayloadAction<string>) => {
      state.selectedProcCode = cloneDeep(action.payload);
    },
    setMachCode: (state, action: PayloadAction<string[]>) => {
      state.machCode = cloneDeep(action.payload);
    },
    setStatus: (state, action: PayloadAction<string>) => {
      state.status = cloneDeep(action.payload);
    },
    setArrivalDateFrom: (state, action: PayloadAction<string>) => {
      state.arrivalDateFrom = cloneDeep(action.payload);
    },
    setArrivalDateTo: (state, action: PayloadAction<string>) => {
      state.arrivalDateTo = cloneDeep(action.payload);
    },
    setShipDateFrom: (state, action: PayloadAction<string>) => {
      state.shipDateFrom = cloneDeep(action.payload);
    },
    setShipDateTo: (state, action: PayloadAction<string>) => {
      state.shipDateTo = cloneDeep(action.payload);
    },
  },
});

export const {
  setQueryParams,
  setSelectedPlantCode,
  setSelectedProcCode,
  setMachCode,
  setStatus,
  setArrivalDateFrom,
  setArrivalDateTo,
  setShipDateFrom,
  setShipDateTo,
} = queryParamsSlice.actions;
export default queryParamsSlice.reducer;
